import { defineComponent as o, openBlock as n, createBlock as r, unref as p, mergeProps as l, withCtx as s, createElementVNode as t } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ o({
  name: "IconPriceUpdate",
  __name: "IconPriceUpdate",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const c = a;
    return (m, e) => (n(), r(p(i), l(c, { "view-box": "0 0 24 24" }), {
      default: s(() => [...e[0] || (e[0] = [
        t("path", { d: "M2.25 12A9.75 9.75 0 0 1 12 2.25a9.72 9.72 0 0 1 6.75 2.714V3a.75.75 0 0 1 1.5 0v3.5A1.25 1.25 0 0 1 19 7.75h-3a.75.75 0 0 1 0-1.5h1.916l-.043-.044A8.25 8.25 0 1 0 12 20.25 8.25 8.25 0 0 0 20.25 12a.75.75 0 0 1 1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12" }, null, -1),
        t("path", { d: "M12 5.75a.75.75 0 0 1 .75.75v.931a3.3 3.3 0 0 1 1.194.473c.59.393 1.028 1.027 1.028 1.874a.75.75 0 1 1-1.5 0c0-.265-.116-.464-.36-.626-.266-.178-.668-.29-1.112-.29s-.846.112-1.112.29c-.244.162-.36.361-.36.626 0 .214.08.37.386.562.317.2.741.348 1.284.538l.19.067c.58.205 1.284.465 1.837.899.599.47 1.025 1.145 1.025 2.1 0 1.432-1.169 2.366-2.5 2.623V17.5a.75.75 0 0 1-1.5 0v-.933c-1.331-.257-2.5-1.191-2.5-2.623a.75.75 0 0 1 1.5 0c0 .526.58 1.195 1.75 1.195s1.75-.669 1.75-1.195c0-.433-.164-.695-.45-.92-.333-.26-.81-.452-1.41-.664l-.195-.068c-.51-.177-1.107-.386-1.578-.681-.58-.364-1.09-.936-1.09-1.833 0-.847.44-1.481 1.03-1.874A3.3 3.3 0 0 1 11.25 7.43V6.5A.75.75 0 0 1 12 5.75" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
